module.exports = __webpack_public_path__ + "img/20190619163831546.676417b5.png";